var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page", class: _vm.computedClasses },
    [
      _c(
        "no-ssr",
        [
          _vm.cartAddPopup.node.title
            ? _c("cart-add-popup", {
                attrs: {
                  node: _vm.cartAddPopup.node,
                  message: _vm.cartAddPopup.message,
                },
                model: {
                  value: _vm.cartAddPopup.mode,
                  callback: function ($$v) {
                    _vm.$set(_vm.cartAddPopup, "mode", $$v)
                  },
                  expression: "cartAddPopup.mode",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.noticebarEnabled
            ? _c(
                "site-noticebar",
                _vm._b(
                  { attrs: { "preview-mode": _vm.noticebarInPreviewMode } },
                  "site-noticebar",
                  _vm.salesStyle,
                  false
                )
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sitegateEnabled
            ? _c("sitegate", { attrs: { gate: _vm.siteGate } })
            : _vm.showAgeGate
            ? _c("age-gate", { attrs: { "require-birthdate": false } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("page-top"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "main-wrap",
          class: { active: _vm.menuDisplayed },
          attrs: { id: "main-wrap" },
        },
        [
          _vm.showmobilenavcontent
            ? _c(
                "transition",
                { attrs: { name: "menu-fade" } },
                [
                  _vm.menuDisplayed
                    ? _c(_vm.mobilenavcontent, { tag: "component" })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "page-overlay",
            class: _vm.mobileMenuDisplayPort,
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.triggerHideMobileMenuButton.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "content-wrap" },
            [
              !_vm.errorCode
                ? _c(
                    "router-view",
                    _vm._b({}, "router-view", _vm.ssrBlockedProps, false)
                  )
                : _c("error-page", { attrs: { code: _vm.errorCode } }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isSSR ? _c("page-bottom") : _vm._e(),
          _vm._v(" "),
          _vm.pagebottomcomponent && !_vm.isSSR
            ? _c(_vm.pagebottomcomponent, { tag: "component" })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("below-the-fold"),
      _vm._v(" "),
      _vm.cookiebarEnabled && !_vm.isSSR ? _c("cookiebar") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }